export const PAGE_LOGIN = 'pg_login';
export const PAGE_HOME = 'pg_home';
export const PAGE_SETTINGS = 'pg_settings';
export const NOT_FOUND = 'pg_notFound';
